<template>
    <div v-if="part==='home'" class="w-full h-screen flex flex-col items-center justify-between">
        <div class="flex flex-wrap w-full overflow-y-auto">
            <div class="w-full py-4 px-4 border-b border-gray-200 flex flex-row justify-center sticky top-0">
                <div>Module not activated or configured</div>
            </div>
            <div></div>
        </div>
        <div class="py-2 border-t border-gray-200 bg-white w-full text-center">
            <button @click="back" class="bg-gray-200 mb-2 p-2 px-16 text-indigo-700 rounded-lg focus:bg-indigo-200">Back</button>
        </div>
    </div>
</template>

<script>

    export default {
        name: "NotActive",
        components : {
        },
        data: function() {
            return {
                part: 'home'
            }
        },
        methods: {
            back() {
                this.$emit("back")
            },
        }
    }
</script>

<style scoped>

</style>